import { render, staticRenderFns } from "./nhan-su-hoat-dong.vue?vue&type=template&id=f11be580"
import script from "./nhan-su-hoat-dong.vue?vue&type=script&lang=js"
export * from "./nhan-su-hoat-dong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports